import Box from '@mui/material/Box'
import { CSSProperties, useEffect, useMemo, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import { helper } from 'helper'
import { securityApi } from 'hooks/api/security'
import AnswerLayoutComponent from 'pages/answer/components/answerLayout'
import TabComponent from 'pages/answer/components/tab'
import ShiftAnswerComponent from 'pages/answer/shift/components/shiftAnswer'

const apiCall = {
  getSecurityNames: async (tokens: string[]) => {
    const response =
      await securityApi().filterNameByShiftQuestionnaireTokens(tokens)
    return response.data
  },
}

export default function ShiftLeaderAnswerPage() {
  const [searchParams] = useSearchParams()
  const tokens = searchParams.getAll('token')
  if (tokens.length === 0) {
    return <div>URLが不正です</div>
  }

  // 初期選択は先頭のトークン
  const [selectedToken, setSelectedToken] = useState(tokens[0])

  const [securityNameMap, setSecurityNameMap] = useState<Map<string, string>>(
    new Map<string, string>(),
  )

  const options = useMemo(() => {
    return tokens.map((token) => ({
      label: securityNameMap.get(token) ?? '',
      value: token,
    }))
  }, [tokens])

  // 初期データ取得
  useEffect(() => {
    const apiAction = async () => {
      const response = await apiCall.getSecurityNames(tokens)
      const securityNameMap = new Map<string, string>(
        response.map((security) => [
          security.token,
          helper.formatter.nameFormat(security),
        ]),
      )
      setSecurityNameMap(securityNameMap)
    }
    apiAction().then()
  }, [])

  const handleSelectToken = (value: string) => {
    setSelectedToken(value)
  }

  return (
    <AnswerLayoutComponent title="シフト提出">
      <Box style={containerStyle}>
        <Box style={tabStyle}>
          <TabComponent
            options={options}
            selected={selectedToken}
            onChange={handleSelectToken}
          />
        </Box>
        <ShiftAnswerComponent token={selectedToken} />
      </Box>
    </AnswerLayoutComponent>
  )
}

const containerStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
}

const tabStyle: CSSProperties = {
  paddingTop: '16px',
}
